import { z } from 'zod';
import {
  RATE_MODE_OPTIONS,
  rateModeDefaults,
  rateModeFields,
  refineRateMode,
} from '../../../playground/endpoints/_shared';
import { GENDER_OPTIONS, contributionSchema } from '../_shared';

export { GENDER_OPTIONS, RATE_MODE_OPTIONS };

// Types and required-ness only: capital bounds, entry age, and the premium
// floor are the engine's to enforce and to report, so this page stays a thin
// client over the API.
export const lifeMaxSchema = z
  .object({
    date_of_birth: z
      .string()
      .min(1, 'Requerido')
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD'),
    gender: z.enum(['MALE', 'FEMALE', 'OTHER']),
    ...rateModeFields,
    agreed_premium: z.coerce.number(),
    death_insured_capital: z.coerce.number(),
    accidental_death_insured_capital: z.coerce.number(),
    itp_insured_capital: z.coerce.number(),
    serious_illness_insured_capital: z.coerce.number(),
    contributions: z.array(contributionSchema),
  })
  // The only cross-field rule kept: `rate_mode` is a UI toggle deciding which
  // of two mutually exclusive fields the payload carries, so the form has to
  // resolve it before a request can be built at all.
  .superRefine(refineRateMode);

export type LifeMaxFormValues = z.infer<typeof lifeMaxSchema>;

export const lifeMaxDefaults: LifeMaxFormValues = {
  date_of_birth: '1990-01-01',
  gender: 'MALE',
  ...rateModeDefaults,
  projection_rate: 0.02,
  agreed_premium: 3000,
  death_insured_capital: 150,
  accidental_death_insured_capital: 0,
  itp_insured_capital: 0,
  serious_illness_insured_capital: 0,
  contributions: [],
};
